<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Versandoption bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.delivery-options.update', deliveryOption))">
                <form-fields :form="form" :supplier="supplier" :delivery-option="deliveryOption" :tax-calc-mode-options="taxCalcModeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplier',
            'deliveryOption',
            'taxCalcModeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.deliveryOption.name,
                    description: this.deliveryOption.description,
                    delivery_time: this.deliveryOption.delivery_time,
                    tax_calc_mode: this.deliveryOption.tax_calc_mode,
                    tax_rate: this.deliveryOption.tax_rate,
                    free_delivery_for_all_cart_items: this.deliveryOption.free_delivery_for_all_cart_items,
                    sort_order: this.deliveryOption.sort_order,
                    enabled: this.deliveryOption.enabled,
                    options: this.deliveryOption.options,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>